import { render, staticRenderFns } from "./LinkComponent.vue?vue&type=template&id=88c1b00a&"
import script from "./LinkComponent.vue?vue&type=script&lang=js&"
export * from "./LinkComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports